import { render, staticRenderFns } from "./DataReportFeeStatistics.vue?vue&type=template&id=0c10b8a4&scoped=true"
import script from "./DataReportFeeStatistics.vue?vue&type=script&lang=js"
export * from "./DataReportFeeStatistics.vue?vue&type=script&lang=js"
import style0 from "./DataReportFeeStatistics.vue?vue&type=style&index=0&id=0c10b8a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c10b8a4",
  null
  
)

export default component.exports